import React from "react";
import noFound from "../assets/errorPage/svg/noFound.svg";
import ErrorPage from "../shared/ErrorPage";

const PagedRoute = () => {
  return <ErrorPage image={noFound} title="Uh oh!" />;
};

export default React.memo(PagedRoute);
